/* eslint-disable default-case */
import produce from 'immer';

import {
  types,
  GetKioskHardwareSuccess,
  GetKioskHardwareError,
  GetKioskHardwarePending,
  UpdateKioskHardwarePayload,
  UpdateKioskHardwarePending,
  UpdateKioskHardwareSuccess,
  UpdateKioskHardwareError,
  KioskHardwareActionTypes,
  KioskHardwareState,
  KioskHardware,
  CreateKioskHardwarePayload,
  DeleteKioskHardwarePending,
  CreateKioskHardwarePending,
  DeleteKioskHardwareError,
  CreateKioskHardwareError
} from './types';

// Actions
export const actions = {
  getKioskHardware: (payload: { kioskId: string }): KioskHardwareActionTypes => ({
    type: types.GET_KIOSK_HARDWARE.REQUEST,
    payload
  }),
  resetKioskHardware: () => ({ type: types.RESET_KIOSK_HARDWARE }),
  updateKioskHardware: (payload: UpdateKioskHardwarePayload) => ({
    type: types.UPDATE_KIOSK_HARDWARE.REQUEST,
    payload
  }),
  resetError: () => ({ type: types.RESET_ERROR }),
  resetAction: () => ({ type: types.RESET_ACTION }),
  createKioskHardware: (payload: CreateKioskHardwarePayload): KioskHardwareActionTypes => ({
    type: types.CREATE_KIOSK_HARDWARE.REQUEST,
    payload
  }),
  deleteKioskHardware: (payload: { id: string; kioskId: string }): KioskHardwareActionTypes => ({
    type: types.DELETE_KIOSK_HARDWARE.REQUEST,
    payload
  })
};

// Initial State
export const initialState: KioskHardwareState = {
  kioskHardware: [],
  action: {
    success: false,
    pending: false,
    error: null
  }
};

// Reducer
export const reducer = (
  state: KioskHardwareState = initialState,
  action: KioskHardwareActionTypes
): KioskHardwareState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case types.GET_KIOSK_HARDWARE.SUCCESS:
        draft.kioskHardware = (action as GetKioskHardwareSuccess).payload;
        break;
      case types.UPDATE_KIOSK_HARDWARE.SUCCESS:
        const payload = (action as UpdateKioskHardwareSuccess).payload;
        draft.action.success = true;
        if (draft.kioskHardware.length) {
          const hardwareIndex = draft.kioskHardware.findIndex((kh) => kh.id === (payload as KioskHardware).id);
          if (hardwareIndex > -1) {
            Object.assign(draft.kioskHardware[hardwareIndex], payload);
          }
        }
        break;
      case types.DELETE_KIOSK_HARDWARE.SUCCESS:
      case types.CREATE_KIOSK_HARDWARE.SUCCESS:
        draft.action.success = true;
        break;
      case types.GET_KIOSK_HARDWARE.PENDING:
      case types.UPDATE_KIOSK_HARDWARE.PENDING:
      case types.CREATE_KIOSK_HARDWARE.PENDING:
      case types.DELETE_KIOSK_HARDWARE.PENDING:
        draft.action.pending = (
          action as
            | GetKioskHardwarePending
            | CreateKioskHardwarePending
            | UpdateKioskHardwarePending
            | DeleteKioskHardwarePending
        ).payload;
        break;
      case types.GET_KIOSK_HARDWARE.ERROR:
      case types.UPDATE_KIOSK_HARDWARE.ERROR:
      case types.CREATE_KIOSK_HARDWARE.ERROR:
      case types.DELETE_KIOSK_HARDWARE.ERROR:
        draft.action.error = (
          action as
            | GetKioskHardwareError
            | CreateKioskHardwareError
            | UpdateKioskHardwareError
            | DeleteKioskHardwareError
        ).payload;
        break;
      case types.RESET_KIOSK_HARDWARE:
        draft.kioskHardware = initialState.kioskHardware;
        break;
      case types.RESET_ERROR:
        draft.action.error = initialState.action.error;
        break;
      case types.RESET_ACTION:
        draft.action = initialState.action;
        break;
    }
  });
};
